// extracted by mini-css-extract-plugin
export var actionText = "_o3-4";
export var container = "_o3-0";
export var leftSection = "_o3-1";
export var rightSection = "_o3-2";
export var settingsButton = "_o3-6";
export var settingsIcon = "_o3-7";
export var shortcut = "_o3-5";
export var shortcutGroup = "_o3-3";